/**
 * Configurator API
 * Configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Ce qui change entre un Etl et sa copie : tout le reste, secrets compris, est repris côté serveur.
 */
export interface EtlDuplicateDTO {
    code?: string;
    name?: string;
    description?: string;
    owner?: string;
    /** Non renseigné : la copie garde les affiliés de la source. */
    personalDataAccessPartners?: Array<string>;
}
